//----- Component --------------------------------------------------------/

// Developer :  Nicolas Pascucci

// Creation Date : 11/02/2025

// Version : 1

// Description : historial de las fichas de rrhh

//

//------Changes --------------------------------------------------------------------- -------------//

// Change Date :

// Change by :

// Change description:

//

// Change Date :

// Change by :

// Change description:

//
//========================================================================/
import React, { useState, useEffect, useMemo, useRef } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Container,
  Typography,
  IconButton,
  Grid,
  Box,
  ThemeProvider,
  Tooltip,
  MenuItem,
  ListItemIcon,
  Divider,
  TextField,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { createTheme, useTheme } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
// Boton desplegable
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";
import { useLocation, useNavigate } from "react-router-dom";
import { lightBlue } from "@mui/material/colors";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import DetalleFicha from "./DetalleFicha";
import Ficha_imprimir from "./Ficha_imprimir";
import FileUploadStock from "../FileUploadStock";
import AttachFileIcon from "@mui/icons-material/AttachFile"; //ADJUNTAR IMAGEN
import RepeatIcon from "@mui/icons-material/Repeat";
import CambioTalle from "./CambioTalle";
import DeleteIcon from "@mui/icons-material/Delete";
import EliminarFicha from "./EliminarFicha";
import jsPDF from "jspdf";
import moment from "moment";
import ModalSelectEmpresa from "./ModalSelectEmpresa";

function Historial_fichas() {
  const [fichaImprimir, setFichaImprimir] = useState(false);
  const [eliminar, setEliminar] = useState(false);
  const [rowFicha, setRowFicha] = useState();
  const [openCloseAdj, setOpenCloseAdj] = useState(false); //ADJUNTAR IMAGEN
  const [cambio, setCambio] = useState(false);
  const hoy = new Date();
  const haceUnAnio = new Date();
  haceUnAnio.setFullYear(hoy.getFullYear() - 1);
  const [loading, setLoading] = useState(false);
  const [loadingEmpresa, setLoadingEmpresa] = useState(false);
  const [desde, setDesde] = useState(haceUnAnio.toISOString().split("T")[0]);
  const [hasta, setHasta] = useState(hoy.toISOString().split("T")[0]);
  const [selectEmpresa, setSelectEmpresa] = useState(false)
  const [snackbarOpen, setSnackbarOpen] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');

  const handleOpenCloseAdj = (value) => {
    setOpenCloseAdj(value);
  };

  let navigate = useNavigate();
  //botones
  const location = useLocation();
  const volverAtras = () => {
    navigate(-1);
  };
  const [fichas, setFichas] = useState([]);
  const obtenerFichas = () => {
    if (!desde || !hasta) return;

    const sucursalId = location.state.id;

    fetch(
      `${UrlApi}/stock_ficha_rrhh/fichasxsucfecha/${sucursalId}/${desde}/${hasta}`
    )
      .then((res) => res.json())
      .then((data) => setFichas(data))
      .catch((err) => console.error("Error al obtener fichas:", err));
  };

  useEffect(() => {
    obtenerFichas();
  }, []);

  // const [fichasEmpresa, setFichasEmpresa] = useState([]);
  // const obtenerFichasEmpresa = () => {
  //   if (!desde || !hasta) return;

  //   const sucursalId = location.state.id;

  //   fetch(`${UrlApi}/stock_ficha_rrhh/fichasxempfecha/${desde}/${hasta}`)
  //     .then((res) => res.json())
  //     .then((data) => setFichasEmpresa(data))
  //     .catch((err) => console.error("Error al obtener fichas:", err));
  // };

  // useEffect(() => {
  //   obtenerFichasEmpresa();
  // }, []);
  //************************************TABLA**********************************************************************************/

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const initialState = {
    //para inicializar la tabla, y la cantidad de paginas q se ven ej 5
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const columns = useMemo(
    // TABLA SALIDA
    () => [
      {
        header: "Fecha",
        accessorKey: "fecha_format",
        size: 60,
        type: "date",
        format: "YYYY-MM-DD",
      },
      { header: "Nombre", accessorKey: "nombre_empleado", size: 100 },
      { header: "Apellido", accessorKey: "apellido_empleado", size: 100 },
      // { header: "Domicilio", accessorKey: "domicilio", size: 110 },
      {
        header: "Empresa",
        accessorKey: "nombre_empresa",
        size: 100,
      },
      { header: "Sucursal", accessorKey: "nombre_sucursal", size: 65 },
    ],
    []
  );

  //PDF
  const handleCloseDialogImprimir = () => {
    setFichaImprimir(false);
    // setUpdate(true);
  };

  const componentRef = useRef();

  const handleClickOpenPdf = (row) => {
    setFichaImprimir(true);
    setRowFicha(row);
  };
  const handleClickOpenAdjuntar = (row) => {
    setOpenCloseAdj(true);
    setRowFicha(row);
  };
  const handleClickOpenCambio = (row) => {
    setCambio(true);
    setRowFicha(row);
  };
  const handleCloseDialogCambio = () => {
    setCambio(false);
    obtenerFichas();
  };

  const handleClickOpenEliminar = (row) => {
    setRowFicha(row);
    setEliminar(true);
  };
  const handleCloseDialogEliminar = () => {
    setEliminar(false);
    obtenerFichas();
  };

  // descargar muchas fichas
  const descargarTodasLasFichas = async () => {
    if (fichas.length > 0) {
    setLoading(true);
    try {
      const response = await fetch(
        `${UrlApi}/generacionfichas/generar-fichas-zip`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ fichas, sucursal: location.state.nombre }),
        }
      );

      if (!response.ok) throw new Error("Error en la respuesta del servidor");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `fichas_${moment(Date()).format("YYYY-MM-DD")}_${
        location.state.nombre
      }`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error("Error al descargar:", error);
      alert("Error al generar las fichas");
    } finally {
      setLoading(false);
    }
  }else{
          setSnackbarMessage("No se encontraron fichas para esta sucursal.");
  setSnackbarOpen(true);
  }
  };

  // descargar muchas fichas
  // const descargarTodasLasFichasEmpresa = async () => {
  //   setLoadingEmpresa(true);
  //   try {
  //     // Si ya es un array plano, no uses flat()
  //     const fichasArray = Array.isArray(fichasEmpresa)
  //       ? fichasEmpresa
  //       : Object.values(fichasEmpresa).flat();

  //     // Debug antes del fetch
  //     console.log("¿Es array?", Array.isArray(fichasArray));
  //     console.log("Cantidad de fichas:", fichasArray.length);
  //     console.log("Primer ficha:", fichasArray[0]);

  //     const response = await fetch(
  //       `${UrlApi}/generacionfichas/generar-fichas-zip`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         // 👇 corregido: el backend espera fichasEmpresa, no fichasArray
  //         body: JSON.stringify({ fichas: fichasArray, sucursal: "todas" }),
  //       }
  //     );

  //     if (!response.ok) {
  //       const errorText = await response.text(); // Leer mensaje del backend si hay
  //       console.error("Respuesta no OK:", errorText);
  //       throw new Error("Error en la respuesta del servidor");
  //     }

  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = `fichas_${moment(Date()).format("YYYY-MM-DD")}_todas`;
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();
  //   } catch (error) {
  //     console.error("Error al descargar:", error);
  //     alert("Error al generar las fichas");
  //   } finally {
  //     setLoadingEmpresa(false);
  //   }
  // };

const descargarFichaEspecifica = async (row) => {
  // setLoading(true);
  try {
    // 1. Descargar PDF
    const pdfResponse = await fetch(`${UrlApi}/generacionfichas/generar-pdf-ficha`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ficha: [row] }),
    });

    if (!pdfResponse.ok) throw new Error("Error al descargar PDF");
    const pdfBlob = await pdfResponse.blob();
    const pdfUrl = window.URL.createObjectURL(pdfBlob);
    const pdfLink = document.createElement("a");
    pdfLink.href = pdfUrl;
    pdfLink.download = `R${row.nro_legajo}${row.fecha_format.replace(/-/g, "")}00.pdf`;
    document.body.appendChild(pdfLink);
    pdfLink.click();
    pdfLink.remove();

    // 2. Descargar TXT
    const txtResponse = await fetch(`${UrlApi}/generacionfichas/generar-txt-ficha`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ficha: [row] }),
    });

    if (!txtResponse.ok) throw new Error("Error al descargar TXT");
    const txtBlob = await txtResponse.blob();
    const txtUrl = window.URL.createObjectURL(txtBlob);
    const txtLink = document.createElement("a");
    txtLink.href = txtUrl;
    txtLink.download = `R${row.nro_legajo}${row.fecha_format.replace(/-/g, "")}00.txt`;
    document.body.appendChild(txtLink);
    txtLink.click();
    txtLink.remove();
console.log(row);

  } catch (error) {
    console.error("Error al descargar archivos:", error);
    alert("Error al generar las fichas");
  } finally {
    // setLoading(false);
  }
};

  const handleClickOpenDownload = (row) => {
    setSelectEmpresa(true);
  };
  const handleCloseDialogDownload = () => {
    setSelectEmpresa(false);
  };

  return (
    <div>
      <AppBar sx={{ position: "relative", backgroundColor: "#0979b0" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={volverAtras}
            aria-label="close"
            sx={{ mr: 2 }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Historial de Fichas de {location.state.nombre}
          </Typography>

          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              variant="contained"
              disableElevation
              startIcon={
                loading ? (
                  <CircularProgress
                    size={20}
                    sx={{ color: "#ffffff" }} // 👈 blanco, o gris si preferís
                  />
                ) : (
                  <DownloadIcon />
                )
              }
              sx={{
                backgroundColor: "GrayText",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#757575",
                },
                "&.Mui-disabled": {
                  backgroundColor: "GrayText", // 👈 mantiene gris aunque esté deshabilitado
                  color: "#fff",
                },
              }}
              onClick={descargarTodasLasFichas}
              disabled={loading}
            >
              {loading ? "Generando..." : "Fichas Sucursal"}
            </Button>

            <Button
              variant="contained"
              disableElevation
              startIcon={
                loadingEmpresa ? (
                  <CircularProgress size={20} sx={{ color: "#ffffff" }} />
                ) : (
                  <DownloadIcon />
                )
              }
              sx={{
                backgroundColor: "GrayText",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#9e9e9e",
                },
                "&.Mui-disabled": {
                  backgroundColor: "GrayText",
                  color: "#fff",
                },
              }}
              onClick={handleClickOpenDownload}
              disabled={loadingEmpresa}
            >
              {loadingEmpresa ? "Generando..." : "Fichas Empresa"}
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Container maxWidth="xl" mt={1}>
        <Box mt={2} mb={4}>
          <ThemeProvider theme={tableTheme}>
            <MaterialReactTable
              enableExpandAll={false}
              enableToolbarInternalActions={true} //las acciones al lado del search (agregar y full screen)
              enableGrouping // para permitir agrupar x estado x ej
              layoutMode="grid"
              muiTableHeadCellProps={tableHeadCellProps}
              muiTableBodyCellProps={({ row }) => ({
                align: "left",
                sx: {
                  color: "black",
                  borderColor: "black",
                },
              })}
              enableRowActions={true} // Esto debe estar habilitado
              positionActionsColumn="last"
              enableColumnActions={true} //los puntitos de al lado de los titulos (acciones) -> hay que activarlo para agrupar x estado x ej
              enableColumnFilters={false} //desactiva filtros x  columna
              enableHiding={false} // opcion de ocultar columna pero activando el enablecolumaction
              enableDensityToggle={false} //
              localization={MRT_Localization_ES} //idioma
              enableColumnDragging={false} //para arrastrar columnas
              initialState={initialState}
              muiSearchTextFieldProps={muiSearchTextFieldProps}
              columns={columns}
              data={fichas} //con lo q la completas (esto cambia siempre)
              enableStickyFooter
              // enableEditing
              // ACCIONES
              renderToolbarInternalActions={(
                { table } // boton para nuevo , al lado del buscar
              ) => (
                <>
                  <MRT_FullScreenToggleButton table={table} />
                </>
              )}
              renderTopToolbarCustomActions={() => (
                <Box>
                  <TextField
                    sx={{ marginRight: 2 }}
                    focused
                    size="small"
                    label="Desde"
                    type="date"
                    value={desde}
                    onChange={(e) => setDesde(e.target.value)}
                  />
                  <TextField
                    sx={{ marginRight: 2 }}
                    type="date"
                    value={hasta}
                    onChange={(e) => setHasta(e.target.value)}
                    focused
                    size="small"
                    label="hasta"
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => obtenerFichas()}
                    disabled={!desde || !hasta}
                  >
                    Buscar
                  </Button>
                </Box>
              )}
              renderDetailPanel={({ row }) => (
                <DetalleFicha row={row.original} />
              )}
              renderRowActionMenuItems={({ closeMenu, row }) => [
                <MenuItem
                  key={0}
                  onClick={() => {
                    descargarFichaEspecifica(row.original);
                    closeMenu();
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <DownloadIcon color="primary" />
                  </ListItemIcon>
                  Descargar Ficha
                </MenuItem>,
                <MenuItem
                  key={1}
                  onClick={() => {
                    handleClickOpenAdjuntar(row.original);
                    closeMenu();
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <AttachFileIcon color="primary" />
                  </ListItemIcon>
                  Adjuntar
                </MenuItem>,
                <MenuItem
                  key={2}
                  onClick={() => {
                    handleClickOpenCambio(row.original);
                    closeMenu();
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <RepeatIcon color="secondary" />
                  </ListItemIcon>
                  Cambio de talle
                </MenuItem>,
                <MenuItem
                  key={3}
                  onClick={() => {
                    handleClickOpenEliminar(row.original);
                    closeMenu();
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <DeleteIcon color="error" />
                  </ListItemIcon>
                  Eliminar Ficha
                </MenuItem>,
              ]}
            />
          </ThemeProvider>
        </Box>
      </Container>
              <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity="error" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {fichaImprimir ? (
        <Ficha_imprimir
          fichaImprimir={fichaImprimir}
          componentRef={componentRef}
          row={rowFicha}
          onClose={() => handleCloseDialogImprimir(false)}
        />
      ) : null}
      {openCloseAdj ? ( // ADJUNTAR IMAGEN
        <FileUploadStock
          fileId={rowFicha.uuid_ficha}
          openclose={true}
          mostrar={true}
          onClose={() => handleOpenCloseAdj(false)} // Proporciona una función de cierre
        />
      ) : null}
      {cambio ? (
        <CambioTalle
          cambio={cambio}
          open={setCambio}
          row={rowFicha}
          location={location.state}
          onClose={() => handleCloseDialogCambio(false)}
        />
      ) : null}
      {eliminar ? (
        <EliminarFicha
          eliminar={eliminar}
          open={setEliminar}
          row={rowFicha}
          location={location.state}
          onClose={() => handleCloseDialogEliminar(false)}
        />
      ) : null}
      {selectEmpresa ? (
        <ModalSelectEmpresa
          selectEmpresa={selectEmpresa}
          open={setSelectEmpresa}
          location={location.state}
          onClose={() => handleCloseDialogDownload(false)}
        />
      ) : null}
    </div>
  );
}

export default Historial_fichas;
